import { createAction } from 'redux-actions';

import types from './types';

const loadProvinces = createAction(types.LOAD_PROVINCES);
const loadTowns = createAction(types.LOAD_TOWNS);
const setProvinces = createAction(types.SET_PROVINCES);
const setTowns = createAction(types.SET_TOWNS);
const setProvince = createAction(types.SET_PROVINCE);
const setTown = createAction(types.SET_TOWN);
const setStore = createAction(types.SET_STORE);
const initialize = createAction(types.INITIALIZE);
const resetSelections = createAction(types.RESET_SELECTIONS);

export default {
    loadProvinces,
    loadTowns,
    setProvinces,
    setTowns,
    setProvince,
    setTown,
    setStore,
    initialize,
    resetSelections,
};
